module.exports = __webpack_public_path__ + "static/thumbnail-252d76472fab4545c8db86324c0b27ac.png";